









































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { ExperimentGetter, Quiz, User } from 'frontend/types';
import LessonButton from 'frontend/views/courses/CoursePage/components/LessonButton.vue';
import ProgressBar from 'frontend/views/courses/CoursePage/components/ProgressBar.vue';
import { buildPremiumRedirect } from 'frontend/utils/premium-redirect';
import animationTimings, {
  animationsEventBus,
} from 'frontend/views/courses/CoursePage/utils/animationTimings';
import LessonAdmin from 'frontend/views/courses/CoursePage/components/LessonAdmin.vue';

@Component({
  components: {
    ProgressBar,
    LessonButton,
    LessonAdmin,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('response', ['requestPath']),
    ...mapGetters('globals', ['inExperiment']),
  },
})
export default class Lesson extends Vue {
  @Prop({ type: Object, required: true })
  private lesson!: Quiz;
  @Prop({ type: Number, required: true })
  private courseId!: number;
  @Prop({ type: Boolean, required: true })
  private isLocked!: boolean;
  @Prop({ type: Boolean, required: true })
  private isRecommended!: boolean;
  @Prop({ type: Boolean, default: false })
  private isLast!: boolean;
  @Prop({ type: Boolean, default: false })
  private isPreviousLesson!: boolean;
  @Prop({ type: Boolean, default: false })
  private enableJustCompletedAnimation!: boolean;

  private readonly user!: User;
  private readonly requestPath!: string;
  private readonly inExperiment!: ExperimentGetter;

  private animationsStarted: boolean = false;

  private get hasPractice(): boolean {
    return !!this.lesson.practice_lessons.length;
  }

  private get timingAnimationVariables(): { [key: string]: string } {
    return {
      '--line-start': `${animationTimings.lineStart}ms`,
      '--line-duration': `${animationTimings.lineDuration}ms`,
    };
  }

  private get isInShowPracticeProblemsExperiment(): boolean {
    return this.inExperiment('show_practice_problems_2023_03', 'experiment');
  }

  private get completionPercentage(): number {
    if (this.lesson.user_activity.total) {
      return this.lesson.user_activity.num_complete / this.lesson.user_activity.total;
    }
    return 0;
  }

  private mounted(): void {
    animationsEventBus.$on('start-animations', () => {
      this.animationsStarted = true;
    });
  }

  private preventIfLocked(event: Event): void {
    if (!this.user.is_authenticated || this.isLocked) {
      event.preventDefault();
      this.preventAccess();
    }
  }

  private preventAccess(): void {
    if (!this.user.is_authenticated) {
      this.$store.dispatch('signupModal/signup');
    } else if (this.isLocked) {
      const premiumRedirect = buildPremiumRedirect({
        user: this.user,
        requestPath: this.requestPath,
        axId: 'clicked_b2_course_landing_locked_quiz',
        targetObjectId: this.lesson.quiz_id,
        targetObjectType: 'quiz',
        targetObjectReferrer: this.$route.path,
      });
      this.$router.push(premiumRedirect);
    }
  }
}
